import { ElMessage } from "element-plus";
import cnchar from "cnchar";
import * as Settings from "../settings";
import moment from "moment";

export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

/**
 * 校验请求响应结果的Code值，做出统一的异常提示
 * @param response
 */
export function checkResponseCode(response) {
  if (response.code != 20000 && response.code != 0) {
    ElMessage({
      message: response.msg,
      type: "error",
      duration: 3 * 1000,
    });
    return null;
  } else {
    const _data = response.data;
    return _data;
  }
}

const title = Settings.projectTitle;

export function getPageTitle(pageTitle) {
  // if (pageTitle) {
  //     return `${pageTitle} - ${title}`;
  // }
  // return `${title}`;
  return `${title}`;
}

/**
 * 自定义排序方法
 */
export function customSortMethod(column, dataList) {
  const prop = column.prop;
  let numberList = [];
  let stringList = [];
  let chineseList = [];
  let blankList = [];
  let temp;
  //数据只有0或1条，则直接返回
  if (dataList.length <= 1) return dataList;
  for (let i = 0; i < dataList.length; i++) {
    if (/^[-]?[0-9]+$/.test(dataList[i][prop])) {
      numberList.push(dataList[i]);
    } else if (dataList[i][prop] == null || dataList[i][prop] === "") {
      blankList.push(dataList[i]);
    } else if (
      /^[-]?[0-9]/.test(dataList[i][prop][0]) ||
      /^[A-Za-z]/.test(dataList[i][prop][0])
    ) {
      stringList.push(dataList[i]);
    } else {
      chineseList.push(dataList[i]);
    }
  }
  if (column.order === "ascending" || column.order == null) {
    for (let i = 1; i < numberList.length; i++) {
      for (let j = i; j > 0; j--) {
        if (parseInt(numberList[j][prop]) < parseInt(numberList[j - 1][prop])) {
          temp = numberList[j];
          numberList[j] = numberList[j - 1];
          numberList[j - 1] = temp;
        } else break;
      }
    }
    for (let i = 1; i < stringList.length; i++) {
      for (let j = i; j > 0; j--) {
        if (
          stringList[j][prop].spell("low") <
          stringList[j - 1][prop].spell("low")
        ) {
          temp = stringList[j];
          stringList[j] = stringList[j - 1];
          stringList[j - 1] = temp;
        } else break;
      }
    }
    for (let i = 1; i < chineseList.length; i++) {
      for (let j = i; j > 0; j--) {
        if (
          chineseList[j][prop].spell("low") <
          chineseList[j - 1][prop].spell("low")
        ) {
          temp = chineseList[j];
          chineseList[j] = chineseList[j - 1];
          chineseList[j - 1] = temp;
        } else break;
      }
    }
    dataList = [];
    dataList = dataList.concat(numberList, stringList, chineseList, blankList);
  } else if (column.order === "descending") {
    for (let i = 1; i < numberList.length; i++) {
      for (let j = i; j > 0; j--) {
        if (parseInt(numberList[j][prop]) > parseInt(numberList[j - 1][prop])) {
          temp = numberList[j];
          numberList[j] = numberList[j - 1];
          numberList[j - 1] = temp;
        } else break;
      }
    }
    for (let i = 1; i < stringList.length; i++) {
      for (let j = i; j > 0; j--) {
        if (
          stringList[j][prop].spell("low") >
          stringList[j - 1][prop].spell("low")
        ) {
          temp = stringList[j];
          stringList[j] = stringList[j - 1];
          stringList[j - 1] = temp;
        } else break;
      }
    }
    for (let i = 1; i < chineseList.length; i++) {
      for (let j = i; j > 0; j--) {
        if (
          chineseList[j][prop].spell("low") >
          chineseList[j - 1][prop].spell("low")
        ) {
          temp = chineseList[j];
          chineseList[j] = chineseList[j - 1];
          chineseList[j - 1] = temp;
        } else break;
      }
    }
    dataList = [];
    dataList = dataList.concat(chineseList, stringList, numberList, blankList);
  }
  return dataList;
}

export function searchString(term, str) {
  return str.toUpperCase().indexOf(term.toUpperCase()) >= 0;
}

export function formatDateTime(datetime, format) {
  return moment(datetime).format(format || "YYYY-MM-DD HH:mm");
}

const mags = ' KMGTPEZY';
export function humanSize(bytes, precision) {
  const magnitude = Math.min(Math.log(bytes) / Math.log(1024) | 0, mags.length - 1);
  const result = bytes / Math.pow(1024, magnitude);
  const suffix = mags[magnitude].trim();
  return result.toFixed(precision) + suffix;
}

export function getRandomPassword() {
  const length = 4;//Math.round(Math.random() * 2 + 2);
  const chars = "0123456789abcdehkmnstuvwxzABCDEHKMNSTUVWXZ";

  let password = "";
  for (let i = 0; i < length; i++) {
    password += chars[Math.floor(Math.random() * chars.length)];
  }
  return password;
}

export async function readFileAsDataURL(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      resolve(reader.result);
    };
    reader.onerror = function (error) {
      reject(error);
    };
  });
}

export function getDownloadBaseUrl(router) {
  //const res = router.resolve({ name: "Download", params: { uri: 'uriPlaceholder' } });
  // location.origin + res.href.replace('uriPlaceholder', '');
  return Settings.mainServerUrl+"/d/";
}

export function isComputer() {
  var agent = navigator.userAgent;
  var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (agent.indexOf(Agents[v]) > 0) { flag = false; break; }
  }
  return flag;
}

export function isWeiXin() {
  const ua = window.navigator.userAgent.toLowerCase();

  return /MicroMessenger/i.test(ua);
}

//检查是IPHONE还是安卓
export function isiOsorAndroid() {
  const u = navigator.userAgent;
  if (u.indexOf('Android') > -1 || u.indexOf('Adr') > -1) { //android终端
    return 2;
  } else if (/\(i[^;]+;( U;)? CPU.+Mac OS X/.test(u)) { //ios终端
    return 1;
  }
}

export function formatList(items, key, sep) {
  key = key || "name";
  return (items || []).map(function (item) {
    return item[key] || item;
  }).join(sep || "、");
}

export function formatmambersList(items, key, sep) {
  return (items || []).map(function (item) {
    return item['name'] + "(" + item['fullname'] + ")";
  }).join(sep || "、");
}

export function humanSizePackage(bytes) {
  let rtnum = bytes / Math.pow(1024, 2);
  if (rtnum > 0.1) {
    rtnum = Math.round(rtnum * 10) / 10 + 'M';
  } else {
    rtnum = Math.round(bytes / 1024) + "KB";
  }
  return rtnum;
}
